// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__ye4na","list":"BalanceDue_list__kpaGQ","listRow":"BalanceDue_listRow__nrxyp","total":"BalanceDue_total__1mhSb"};